// Never imply an unrelated stock photo depicts a news event or a place.
// The transparent pixel leaves the component's neutral editorial background visible.
export const fallbackImageForCategory = () => "data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs=";
export const imageForStory = (story) => {
  const url = story?.image_url;
  return typeof url === "string" && /^https?:\/\//i.test(url) ? url : null;
};